import React from 'react';
import {
  View,
  StyleSheet,
} from 'react-native';
import { Text } from '@/components/common/text';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

interface MobileEmptyStateProps {
  /** SVG icon component to display */
  icon: React.ReactNode;
  /** Title text */
  title: string;
  /** Description text */
  description: string;
  /** Custom icon container width (default: 68) */
  iconWidth?: number;
  /** Custom icon container height (default: 68) */
  iconHeight?: number;
}

/**
 * Mobile Empty State Component
 * Reusable dark theme empty state for linked accounts/invitations
 * Matches Figma design patterns
 */
export const MobileEmptyState: React.FC<MobileEmptyStateProps> = ({
  icon,
  title,
  description,
  iconWidth = 68,
  iconHeight = 68,
}) => {
  const { colors } = useThemeColors();

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {/* Icon */}
        <View style={[styles.iconContainer, { width: iconWidth, height: iconHeight }]}>
          {icon}
        </View>

        {/* Text */}
        <View style={styles.textContainer}>
          <Text style={[styles.title, { color: colors.text.primary }]}>{title}</Text>
          <Text style={[styles.description, { color: colors.text.muted }]}>{description}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 90, // Offset for visual centering
  },
  content: {
    alignItems: 'center',
    gap: 18,
  },
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer: {
    alignItems: 'center',
    gap: 6,
    width: 240,
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.cardTitleLarge,
    textAlign: 'center',
    lineHeight: 24,
  },
  description: {
    ...REDESIGN_TYPOGRAPHY.body,
    textAlign: 'center',
    lineHeight: 21,
  },
});
